import axios from "axios";

export const getUserIp = async () => {
  // return await axios.get(`https://ipapi.co/json/`);
  return await axios.get(`https://api.ipify.org?format=json`);
};